import { Link } from 'react-router-dom';

import { Card, CardBody } from '@/shared/ui/Card';
import { Icon } from '@/shared/ui/Icon';
import { IconChip } from '@/shared/ui/IconChip';
import { LogoSymbol } from '@/shared/ui/Logo';

/**
 * Telas de estado: pagina nao encontrada e acesso negado (os /error-404 e
 * /error-401 do OnPoint).
 *
 * As duas tem "Voltar para o inicio", como no OnPoint. O inicio e o painel; a tela
 * inicial por perfil e de outro pacote (P-USU-1).
 */

function VoltarParaOInicio({ para = '/' }: { para?: string }) {
  return (
    <Link
      to={para}
      className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-brand-600 hover:underline"
    >
      <Icon name="chevronLeft" size={15} />
      Voltar para o inicio
    </Link>
  );
}

/** Pagina nao encontrada, dentro da moldura da empresa. */
export function NotFoundPage() {
  return (
    <Card>
      <CardBody className="py-16 text-center">
        <h2 className="text-base font-semibold text-ink-900">Pagina nao encontrada</h2>
        <p className="mt-2 text-sm text-ink-500">
          O endereco acessado nao existe ou nao esta disponivel para o seu acesso.
        </p>
        <VoltarParaOInicio />
      </CardBody>
    </Card>
  );
}

/**
 * Pagina nao encontrada fora da sessao.
 *
 * Antes, todo endereco desconhecido mandava para o acesso, como se a pagina
 * existisse e so faltasse entrar. O endereco que nao existe diz isso a quem nao
 * entrou, e o caminho de volta e a tela de acesso.
 */
export function PublicNotFoundPage() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-canvas px-5 py-10">
      <div className="w-full max-w-md text-center">
        <div className="mb-6 flex justify-center">
          <LogoSymbol size={48} />
        </div>
        <h1 className="text-xl font-semibold text-ink-900">Pagina nao encontrada</h1>
        <p className="mt-2 text-sm text-ink-500">O endereco acessado nao existe.</p>
        <VoltarParaOInicio para="/entrar" />
      </div>
    </div>
  );
}

/**
 * Acesso negado.
 *
 * A decisao e do servidor, a cada requisicao. Esta tela so diz a pessoa o que
 * aconteceu e por onde seguir.
 */
export function AccessDeniedPage() {
  return (
    <Card>
      <CardBody className="py-16 text-center">
        <IconChip icon="lock" tone="danger" size="lg" className="mx-auto" />
        <h2 className="mt-4 text-base font-semibold text-ink-900">Acesso negado</h2>
        <p className="mt-2 text-sm text-ink-500">
          O seu perfil nao permite abrir esta pagina. Se voce precisa dela, fale com
          quem administra o acesso da sua empresa.
        </p>
        <VoltarParaOInicio />
      </CardBody>
    </Card>
  );
}
